import ReCAPTCHA from "react-google-recaptcha";
import {useDarkMode} from "../../context";
import {config} from "../../utils2";


export function CustomRecaptcha({onChange}) {
    const {darkMode} = useDarkMode()

    return <ReCAPTCHA
        key={darkMode ? "dark" : "light"}
        sitekey={config.get_recaptcha()}
        size="normal"
        theme={darkMode ? "dark" : "light"}
        onChange={onChange}
    />
}
